/**
 * A QUIEN SE LE MANDA UNA SOLICITUD, Y CONTRA QUE FICHA SE ARCHIVA.
 *
 * Lissette, punto 73b: *"al enviar una aplicacion, buscar el cliente en el CRM
 * o escribir los datos"*.
 *
 * ── POR QUE HACIA FALTA ─────────────────────────────────────────────────────
 *
 * La ventana de enviar se abre desde dos sitios y hasta hoy se portaban
 * distinto:
 *
 *   - Desde la FICHA de un cliente: venia con su nombre, su correo y —lo que
 *     de verdad importa— su `clientId`. Todo bien.
 *   - Desde el modulo de Aplicaciones: venia vacia. El agente escribia el
 *     nombre a mano y la solicitud salia SIN vincular. Cuando el cliente la
 *     llenaba, Deskte no tenia contra que ficha archivarla y creaba una NUEVA
 *     como prospecto.
 *
 * Resultado: al cliente que YA existia se le duplicaba la ficha, y los datos
 * que el agente ya tenia guardados no se rellenaban solos. Sin un solo error.
 *
 * ── LAS DOS REGLAS QUE VIVEN AQUI ───────────────────────────────────────────
 *
 * 1. Elegir una ficha rellena el nombre y el correo Y vincula la fila.
 * 2. Escribir a mano sigue funcionando: hay gente que todavia NO es cliente, y
 *    esa es justo la que se captura con una solicitud. Por eso soltar la ficha
 *    no borra lo escrito.
 *
 * El vinculo es POR FILA. Antes solo la primera podia llevarlo, porque era la
 * unica que podia venir de una ficha; mandando tres solicitudes a tres clientes
 * distintos, dos salian sueltas.
 */

/** Una fila vacia, sin ficha detras. */
export function filaDeDestinatario(nombre = '', correo = '', clientId = null) {
  return { name: nombre || '', email: correo || '', clientId: clientId || null };
}

/**
 * Elegir (o soltar) la ficha de la fila `i`.
 *
 * `id` vacio = soltarla. Soltar **no borra** el nombre ni el correo: quien
 * suelta suele ser alguien que se dio cuenta de que es otra persona con un
 * nombre parecido, y volver a escribirlo todo seria un castigo por corregirse.
 *
 * Lo que la ficha aporta solo PISA lo que esta vacio si trae algo: un cliente
 * sin correo en su ficha no debe borrar el correo que el agente acaba de
 * escribir a mano.
 */
export function vincularDestinatario(filas, i, id, clientes) {
  return (filas || []).map((x, j) => {
    if (j !== i) return x;
    if (!id) return { ...x, clientId: null };
    const c = (clientes || []).find((y) => y && y.id === id);
    if (!c) return { ...x, clientId: id };
    return {
      ...x,
      clientId: id,
      name: `${c.firstName || ''} ${c.lastName || ''}`.trim() || x.name,
      email: c.email || x.email,
    };
  });
}

/**
 * Las filas que de verdad se envian, ya limpias.
 *
 * Se descarta la fila del todo vacia —el agente pulso "Agregar persona" y no
 * la lleno— pero NUNCA por no tener correo: una solicitud sin correo genera el
 * enlace para que el agente lo comparta a mano, y eso es una forma de uso, no
 * un error (Lissette, 2026-06-22).
 */
export function destinatariosQueSeEnvian(filas) {
  return (filas || [])
    .map((r) => ({
      name: String(r?.name || '').trim(),
      email: String(r?.email || '').trim(),
      clientId: r?.clientId || null,
    }))
    .filter((r) => r.name || r.email);
}
